import { HOW_GET_DEAL } from 'shared/constants/howGetDeal';
import { Title } from '../Title';
import * as style from './styles.css';
import { ITypographyComponentProps, TDeviceType, TMemoForwardRefComponent } from '@cian/ui-kit';
import { clsx } from 'clsx';

interface IHowGetDealProps {
  device: TDeviceType;
  ItemTitle: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
  Description: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
}

export const HowGetDeal: React.FC<IHowGetDealProps> = ({ device, ItemTitle, Description }) => {
  return (
    <div className={clsx(style['container'], style[device])}>
      <Title>Как выйти на сделку со скидкой на ипотеку?</Title>
      <div className={style['list']}>
        {HOW_GET_DEAL.map(({ id, title, descr, list, imageClass }) => (
          <div className={style['item']} key={id}>
            <div className={style['title']}>
              <ItemTitle>{title}</ItemTitle>
            </div>
            <div className={style['descr']}>
              <Description>{descr}</Description>
            </div>
            {list.map((elem, index) => (
              <ul className={style['item-list']} key={index}>
                <li>
                  <Description>{elem}</Description>
                </li>
              </ul>
            ))}
            <div className={clsx(style['image'], style[imageClass])} />
          </div>
        ))}
      </div>
    </div>
  );
};
